var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-data-table',{attrs:{"headers":_vm.header,"items":this.Items.sale_form_of_payment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }